export default function Logo({ className = "", size = "text-xl" }) {
  return (
    <span className={`font-display font-extrabold tracking-tight ${size} ${className}`} data-testid="brand-logo">
      inter<span className="brand-ko">KO</span>
    </span>
  );
}
